import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GlossaryBookmark from './icon-glossary-bookmark.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GlossaryBookmark {...validProps} color={validProps.color || colors.blue} />;
}

SvgComponent.iconName = 'glossary-bookmark';

/**
 * @deprecated This is a legacy icon
 */
export const GlossaryBookmarkIcon = svgIconWrapper(SvgComponent);
